import styled from "styled-components"
import { Row, Col, Accordion } from "react-bootstrap";
import { BPSAccordionStyled } from "../styled/BPSAccordion";

import DetailedReporting from '../../assets/images/Rebates - Detailed Analytics.png';
import EfficientValidation from '../../assets/images/Rebates - Pending Claims.png';
import Security from '../../assets/images/Rebates - Top Security.png';
import Communication from '../../assets/images/Rebates - Engaging Communication.png';

import { BPSCheckmarkList, Checkmark } from "../styled/Lists";


const ReferralAccordion = () => {
    return (
        <BPSAccordionStyled>
            <Accordion defaultActiveKey="0" >
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Get more B2B leads</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            With a staggering 84% of B2B buyers initiating their purchase journey through a referral, your business can’t afford to ignore this powerful tool. Referral programs don't just generate leads; they cultivate high-quality, viable connections. This provides a strong sales pipeline that keeps delivering year after year.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Decrease costs & increase ROI</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            Referrals can have a massive effect on your company’s budget - both saving money on lead generation and increasing your sales at the same time. Businesses with structured referral programs are three times more likely to hit their revenue targets. Studies have also shown referral programs are a much more cost-effective way of generating leads for your business. Investing in a referral program is a key way to guide your company to sustainable financial growth.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                    <Accordion.Header>Get ahead of the competition</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            When you know 65% of new business comes from referrals, it may surprise you to learn only 3 in 10 B2B companies have a formal referral program. With a referral program, you're not just adopting a strategy; you're pulling ahead of the competition.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </BPSAccordionStyled>
    );
}


export { ReferralAccordion }
